export const parseServiceResponse = <T>(response: any): T & ServiceResponseType => {
    let data;
    if (response?.data?.itemList) {
        if (response?.data?.itemList?.length) {
            data = response?.data?.itemList[0]
        }
        else {
            data = response?.data?.itemList
        }
    }
    else {
        data = response?.data
    }
    return {
        ...data || {},
        status: response?.status || -1,
    } as T & ServiceResponseType;
};
export interface ServiceResponseType {
    status: number;
    message?: string;
    place_holder?: string;
    [key: string]: any;
}
